/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {

    connectedCallback() {
      this.ticking = false;
      this.footerOffset = 160;
      this._onScroll = this.checkVisible.bind(this);
      this._onResize = this.onResize.bind(this);

      this.pageHeight = window.innerHeight;

      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, { passive: true });
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });

      this.updatePosition();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    getBaseBottom() {
      return window.matchMedia('(min-width: 1024px)').matches ? 30 : 20;
    }

    updatePosition() {
      const footer = document.querySelector('footer.opk_footer');
      let bottom = this.getBaseBottom();

      if (footer) {
        const { top } = footer.getBoundingClientRect();
        if (top < window.innerHeight) {
          bottom = this.footerOffset;
        }
      }

      this.style.bottom = `${bottom}px`;
    }

    onResize() {
      this.pageHeight = window.innerHeight;
      this.updatePosition();
    }

    checkVisible() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.classList.toggle('back-to-top--active', window.scrollY > this.pageHeight);
        this.updatePosition();
        this.ticking = false;
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}
